import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchChakraAvailability() {
  try {
    const result = yield call(AxiosCall, `/chakras/get_availability/`);
    yield put(actions.fetchChakraAvailabilitySuccess(result.data.available));
  } catch (e) {
    yield put(actions.fetchChakraAvailabilityFailure(e));
  }
}

function* fetchChakraQuestionnaire() {
  try {
    const result = yield call(AxiosCall, `/chakras/get_questionnaire/`);
    const { results } = result.data;
    yield put(actions.fetchChakraQuestionnaireSuccess(results));
  } catch (e) {
    yield put(actions.fetchChakraQuestionnaireFailure(e));
  }
}

function* submitChakraQuestionnaire(action) {
  try {
    const result = yield call(AxiosPost, `/chakras/submit_questionnaire/`, action.payload);
    const reading = result.data.results?.at(0);
    if (!reading) {
      const response = result.data.response;
      if (response === "CHAKRA_READING_CONSUMED") {
        throw new Error("Ya realizaste tu consulta diaria de Chakras");
      }
      throw new Error("Error al procesar el cuestionario");
    }
    yield put(actions.submitChakraQuestionnaireSuccess(reading));
  } catch (e) {
    yield put(actions.submitChakraQuestionnaireFailure(e));
  }
}

function* fetchAllChakras() {
  try {
    const result = yield call(AxiosCall, `/chakras/get_chakras/`);
    const { results } = result.data;
    yield put(actions.fetchAllChakrasSuccess(results));
  } catch (e) {
    yield put(actions.fetchAllChakrasFailure(e));
  }
}

function* captureChakraLead(action) {
  try {
    yield call(AxiosPost, `/marketing/capture_lead/`, action.payload);
    yield put(actions.captureChakraLeadSuccess());
  } catch (e) {
    yield put(actions.captureChakraLeadFailure(e));
  }
}

function* setChakraReadingLike(action) {
  try {
    yield call(AxiosPost, `/chakras/set_reading_like/`, action.payload);
    yield put(actions.setChakraReadingLikeSuccess());
  } catch (e) {
    yield put(actions.setChakraReadingLikeFailure(e));
  }
}

export default function* chakrasSaga() {
  yield all([
    takeLatest(actions.FETCH_CHAKRA_AVAILABILITY_REQUEST, fetchChakraAvailability),
    takeLatest(actions.FETCH_CHAKRA_QUESTIONNAIRE_REQUEST, fetchChakraQuestionnaire),
    takeLatest(actions.FETCH_ALL_CHAKRAS_REQUEST, fetchAllChakras),
    takeLatest(actions.SUBMIT_CHAKRA_QUESTIONNAIRE_REQUEST, submitChakraQuestionnaire),
    takeLatest(actions.SET_CHAKRA_READING_LIKE_REQUEST, setChakraReadingLike),
    takeLatest(actions.CAPTURE_CHAKRA_LEAD_REQUEST, captureChakraLead),
  ]);
}
